<div class="mainContainer card overflow-auto margin mt-4">
    <div class="loader" *ngIf="loading">
        <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
        <h5 class="card-title ps-4 mb-0 tableTitle"> {{totalCount}} Job(s)</h5>
        <div class="form-inline ms-auto me-4 d-none d-md-flex hstack card-title ps-4 mb-0">
            <div class="input-group input-group-sm input-group-inline"><span class="input-group-text pe-2"><i
                class="bi bi-search"></i> </span><input type="email" class="form-control" placeholder="Search Jobs"
              aria-label="Search" [(ngModel)]="jobSearch" (keyup)="searchJob()">
          </div>
        </div>
    </div>
    <table matSort (matSortChange)="sortData($event)" class="table table-hover table-nowrap">
        <thead class="table-light">
          <tr>
            <th mat-sort-header="title" scope="col" class="ps-5">Name</th>
            <th mat-sort-header="title" scope="col" class="ps-5">Client</th>
            <th mat-sort-header="title" scope="col" class="ps-5">Candidate Name</th>
            <th mat-sort-header="start_date" scope="col">Start Date</th>
            <th mat-sort-header="end_date" scope="col">End Date</th>
            <th mat-sort-header="status" scope="col">Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let job of allJobs"  style="cursor: pointer;" class="dataColumn">
                <td (click)="openAuditTrail(job)">
                  <div class="textWithIcon" matTooltip="{{job.description ?? '--'}}" [matTooltipPosition]="'below'">
                    <i class="bi bi-briefcase"></i>
                    <span class="text-heading font-semibold">{{job.title}}</span>
                  </div>
                </td>
                <td matTooltip="{{job.location ?? '--'}}" [matTooltipPosition]="'below'">{{job.client ?? '--'}}</td>
                <td>{{job.contractors.join(', ') ?? '--'}}</td>
                <td>{{dataSharedService.tranformDate(job.start_date)}}</td>
                <td>{{dataSharedService.tranformDate(job.end_date)}}</td>
                <td>
                  <span *ngIf="job.status === 2">Request Sent</span>
                  <span *ngIf="job.status === 3">Details Submitted</span>
                  <span *ngIf="job.status === 4">Rejected</span>
                  <span *ngIf="job.status === 5">Permanent Rejected</span>
                  <span *ngIf="job.status === 6">Details Resubmitted</span>
              </td>
                <td>
                  <div class="row-actions">
                    <button type="button" class="icon-btn-sm info" matTooltip="Edit" [matTooltipPosition]="'left'" (click)="onEdit(job)">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY && job.contract == null && job.status !== 4" class="icon-btn-sm warning" matTooltip="Send Contract" [matTooltipPosition]="'left'" (click)="onEdit(job, true)">
                      <i class="bi bi-c-square"></i>
                    </button>
                    <button type="button" *ngIf="user?.role_uuid === ROLES?.AGENCY || job.status !== 5" class="icon-btn-sm reject" matTooltip="Deactivate job" [matTooltipPosition]="'left'" (click)="inactivateJob(job.uuid)">
                      <i class="bi bi-lock"></i>
                    </button>
                    <button type="button" *ngIf="(user?.role_uuid === ROLES?.AGENCY || user?.role_uuid === ROLES?.SUPER_ADMIN) && (job.status === 3 || job.status === 4 || job.status === 5 || job.status === 6)" class="icon-btn-sm" matTooltip="View Onboarding Form Details Submitted By Candidate" [matTooltipPosition]="'left'" (click)="viewOnBoardingFormDetails(job)">
                      <i class="bi bi-eye"></i>
                    </button>
                  </div>
                </td>
              </tr>
        </tbody>
    </table>
    <div class="card-pagination" *ngIf="totalCount">
      <span class="pagination-summary">
        Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} requests
      </span>
      <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
    </div>
</div>